import React, {Component} from 'react';
import Select from 'react-select';
// import 'react-select/dist/react-select.css';

class DeviceCompatibilityCheck extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            brandSelect: 'Please select a value',
            deviceModelSelect: '',
        };
        this.brands = this.formatOptions(Object.keys(this.props.devices)); 
        this.onChange = this.onChange.bind(this);
    }

    
    componentDidCatch(error, info) {
        console.log('DeviceCompatibilityCheck - error:', error);
        console.log('DeviceCompatibilityCheck - info:', info);
    }

    getBrandSelection() {
        return this.state.brandSelect
    }
    getDevicesForBrand() {
        let selectedBrand = this.getBrandSelection();
        
        if (selectedBrand) {
            selectedBrand = selectedBrand.value;
            return this.props.devices[selectedBrand];
        }
        return; 
    }

    formatOptions(options = []) {
        const formattedOptions = options.map(option => {
            return {'name': option, 'value': option};
        })

        return formattedOptions
    }


    onChange(value, name) {
        // For some reason, name wasn't defined on the event.target, so a work
        // around is to pass the name. Kind of hurts re-usability, but it is what
        // it is.
        this.setState({
            [name]: value,
            step: this.state.step+1
        });
    }
    getValue(stateTreeKey) {
        return this.state[stateTreeKey] ? this.state[stateTreeKey].value : '';
    }

    render() {
        return(
            <div className="DeviceCompatibilityCheck">
                <Select
                    name="brandName"
                    id="brandName"
                    clearable={false}
                    multi={false}
                    value={ this.getValue('brandSelect') }
                    valueKey="value"
                    onChange={ event => this.onChange(event, 'brandSelect')}
                    labelKey="name"
                    placeholder="Select Brand"
                    autoload={false}
                    options={this.brands}
                    searchable={false}
                />

                <Select 
                    name="deviceModelSelect"
                    id="deviceModelSelect"
                    clearable={false}
                    multi={false}
                    value={this.getValue('deviceModelSelect')}
                    onChange={event => this.onChange(event, 'deviceModelSelect')}
                    valueKey="value"
                    labelKey="name"
                    placeholder="Select Model"
                    autoload={false}
                    disabled={this.state.step === 0 ? true : false}
                    options={this.formatOptions(this.getDevicesForBrand()) || []}
                    searchable={false}
                />
            </div>
        )
    }
}


export default DeviceCompatibilityCheck;